import * as React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2, MenuItem, Stack, TextField, Typography, } from "@mui/material";
import Loading from '../../BuiltInComponent/Loading'
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination'
import ModernNavbar from "../setup/ModernNavbar";
import HeadingTest from '../../BuiltInComponent/HeadingTest'
import Footer from '../setup/Footer'
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeForList } from '../../features/PayrollManagement/employeeSlice'
import { addAdvance, editAdvance, getAdvances, getSingleAdvance, deleteAdvance } from "../../features/PayrollManagement/empAdvanceSlice";

import { getAdvanceRecoveries } from '../../features/PayrollManagement/empAdvanceSlice';
import { Alert, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

/******************************************
 * Component: Employee Advance Management *
 ******************************************/
const defaultValues = {
    empID: "",
    advDate: dayjs().format("YYYY-MM-DD"),
    amount: "",
    installments: 1,
    reason: "",
    status: "Pending",
    remarks: "",
    recovered: 0,
};

export default function EmployeeAdvancePage() {

    const dispatch = useDispatch()

    const { empForList, isLoading } = useSelector(state => state.emp)
    const { user } = useSelector(state => state.auth)

    const [rows, setRows] = React.useState([]);
    const [recoveryDialog, setRecoveryDialog] = React.useState(false);
    const [recoveryRows, setRecoveryRows] = React.useState([]);
    const [recoveryLoading, setRecoveryLoading] = React.useState(false);
    const [recoveryError, setRecoveryError] = React.useState('');
    const [selectedAdvance, setSelectedAdvance] = React.useState(null);

    // dialog state
    const [open, setOpen] = React.useState(false);
    const [editRow, setEditRow] = React.useState(null);
    const [advID, setAdvID] = React.useState(0)

    // form state (no react-hook-form)
    const [form, setForm] = React.useState(defaultValues);
    const [errors, setErrors] = React.useState({});

    const tableColumns = [
        { fieldName: 'advID', cName: 'ID', textAlign: 'left', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'advID', cName: '#', textAlign: 'left', width: '25%', dType: 'string', status: 'en' },
        { fieldName: 'empID', cName: 'Emp ID', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Emp ID', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'advDate', cName: 'Date', textAlign: 'left', width: '20%', dType: 'date', status: 'en' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'left', width: '20%', dType: 'number', status: 'en' },
        { fieldName: 'installments', cName: 'Installments', textAlign: 'left', width: '20%', dType: 'number', status: 'en' },
        { fieldName: 'reason', cName: 'Reason', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'status', cName: 'Status', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'recovered_amount', cName: 'Receovered', textAlign: 'left', width: '20%', dType: 'number', status: 'en' },
        { fieldName: 'balance_amount', cName: 'Balance', textAlign: 'left', width: '20%', dType: 'number', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'details', cName: 'Details', textAlign: 'center', width: '8%', status: 'en', buttonText: 'View' },
    ]

    const installmentAmount = React.useMemo(() => {
        const a = parseFloat(form.amount || 0);
        const i = parseInt(form.installments || 1, 10);
        if (!i) return 0;
        return a / i;
    }, [form.amount, form.installments]);

    React.useEffect(() => {
        dispatch(getEmployeeForList())
        dispatch(getAdvances()).then((res) => {
            setRows(res.payload)
        })
    }, [dispatch])

    const onAdd = () => {
        setEditRow(null);
        setForm(defaultValues);
        setErrors({});
        setOpen(true);
    };

    const onEditClick = async (advID) => {
        dispatch(getSingleAdvance(advID)).then((res) => {
            setAdvID(advID)
            setForm(prev => ({
                ...prev,
                empID: res.payload.empID,
                advDate: dayjs(res.payload.advDate).format("YYYY-MM-DD"),
                amount: res.payload.amount,
                installments: res.payload.installments,
                reason: res.payload.reason,
                status: res.payload.status,
                remarks: res.payload.remarks,
                recovered: res.payload.recovered_amount,

            }))
            setEditRow(res.payload);
        })
        setOpen(true);
    };

    const onDeleteClick = async (advID) => {
        dispatch(deleteAdvance(advID)).then(() => {
            dispatch(getAdvances()).then((res) => {
                setRows(res.payload)
            })
        })
    };

    const onRecoveryClick = (advID) => {
        setSelectedAdvance(rows.find((row) => row.advID === advID) || null);
        setRecoveryRows([]);
        setRecoveryError('');
        setRecoveryDialog(true);
        setRecoveryLoading(true);
        dispatch(getAdvanceRecoveries(advID)).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') setRecoveryRows(res.payload || []);
            else setRecoveryError(res.payload || 'Recovery details load nahi ho saken.');
            setRecoveryLoading(false);
        });
    };

    const handleChange = (field) => (e) => {
        const value = e.target.value;
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const validate = () => {
        const e = {};
        if (!form.empID) e.empID = "Employee required";
        if (!form.amount || Number(form.amount) <= 0) e.amount = "Must be > 0";
        if (!form.installments || Number(form.installments) < 1) e.installments = ">= 1";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const onSubmit = async (ev) => {
        ev.preventDefault();
        if (!validate()) return;

        const payload = {
            ...form,
            amount: Number(form.amount),
            installments: Number(form.installments),
            recovered: Number(form.recovered || 0),
            createdBy: user?.userID || null,
            // empName: employees.find((e) => e.empID === Number(form.empID))?.empName,
        };

        if (editRow) {
            dispatch(editAdvance({ advID: advID, payload })).then((res) => {
                dispatch(getAdvances()).then((res) => {
                    setRows(res.payload)
                })
            })
        } else {
            console.log('Reach to Create')
            dispatch(addAdvance(payload)).then((res) => {
                dispatch(getAdvances()).then((res) => {
                    setRows(res.payload)
                })
            })
        }

        setOpen(false);
    };

    return (
        <>
            <ModernNavbar />
            <Grid2 container spacing={2}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <HeadingTest text="Employee Advance" />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ my: 3 }}>
                <Typography></Typography>
                <Button variant="contained" onClick={onAdd}>Add Advance</Button>
            </Stack>

            {isLoading ?
                <>
                    <Loading />
                </> :
                <>
                    <TableDataWithPagination
                        tableColumns={tableColumns}
                        tableData={rows}
                        onEditClick={onEditClick}
                        onDeleteClick={onDeleteClick}
                        onButtonClick={onRecoveryClick}
                        actionIcon='view'
                        canEditRow={(row) => ['Pending', 'OpenForEdit'].includes(row.approvalStatus)}
                        canDeleteRow={(row) => ['Pending', 'OpenForEdit'].includes(row.approvalStatus)}
                    />

                </>}


            {/* Add / Edit Dialog */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>{editRow ? "Edit Advance" : "Add Advance"}</DialogTitle>
                <DialogContent dividers>
                    <Box component="form" id="advance-form" onSubmit={onSubmit} sx={{ mt: 1 }}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={6}>
                                <TextField
                                    select
                                    label="Employee"
                                    fullWidth
                                    size="small"
                                    value={form.empID}
                                    onChange={handleChange("empID")}
                                    error={!!errors.empID}
                                    helperText={errors.empID}
                                >
                                    {empForList.map((e) => (
                                        <MenuItem key={e.empID} value={e.empID}>
                                            {e.empName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    label="Advance Date"
                                    type="date"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    value={form.advDate}
                                    onChange={handleChange("advDate")}
                                />
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    label="Amount"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    inputProps={{ min: 1, step: 1 }}
                                    value={form.amount}
                                    onChange={handleChange("amount")}
                                    error={!!errors.amount}
                                    helperText={errors.amount}
                                />
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    label="Installments"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    inputProps={{ min: 1, step: 1 }}
                                    value={form.installments}
                                    onChange={handleChange("installments")}
                                    error={!!errors.installments}
                                    helperText={errors.installments}
                                />
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    label="Per Installment"
                                    value={Number.isFinite(installmentAmount) ? installmentAmount.toFixed(2) : "0.00"}
                                    fullWidth
                                    size="small"
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid2>

                            <Grid2 size={6}>
                                <TextField
                                    label="Reason"
                                    fullWidth
                                    size="small"
                                    value={form.reason}
                                    onChange={handleChange("reason")}
                                />
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    select
                                    label="Status"
                                    fullWidth
                                    size="small"
                                    value={form.status}
                                    onChange={handleChange("status")}
                                >
                                    {["Pending", "Approved", "Recovered", "Cancelled"].map((s) => (
                                        <MenuItem key={s} value={s}>
                                            {s}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid2>

                            <Grid2 size={3}>
                                <TextField
                                    label="Recovered So Far"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    inputProps={{ min: 0, step: 1 }}
                                    value={form.recovered}
                                    onChange={handleChange("recovered")}
                                />
                            </Grid2>

                            <Grid2 size={12}>
                                <TextField
                                    label="Remarks"
                                    fullWidth
                                    size="small"
                                    multiline
                                    rows={2}
                                    value={form.remarks}
                                    onChange={handleChange("remarks")}
                                />
                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button form="advance-form" type="submit" variant="contained">
                        {editRow ? "Update" : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={recoveryDialog} onClose={() => setRecoveryDialog(false)} maxWidth='md' fullWidth>
                <DialogTitle>Advance Recovery Details{selectedAdvance ? ` - ${selectedAdvance.empName}` : ''}</DialogTitle>
                <DialogContent dividers>
                    {selectedAdvance && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} sx={{ mb: 2 }}>
                            <Typography><strong>Advance:</strong> {Number(selectedAdvance.amount || 0).toLocaleString()}</Typography>
                            <Typography><strong>Recovered:</strong> {Number(selectedAdvance.recovered_amount || 0).toLocaleString()}</Typography>
                            <Typography><strong>Balance:</strong> {Number(selectedAdvance.balance_amount || 0).toLocaleString()}</Typography>
                        </Stack>
                    )}
                    {recoveryLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
                    ) : recoveryError ? (
                        <Alert severity='error'>{recoveryError}</Alert>
                    ) : recoveryRows.length === 0 ? (
                        <Alert severity='info'>Is advance ki abhi koi deduction record nahi hui.</Alert>
                    ) : (
                        <TableContainer component={Paper} variant='outlined'>
                            <Table size='small'>
                                <TableHead><TableRow>
                                    <TableCell><strong>Month</strong></TableCell>
                                    <TableCell><strong>Deduction Date</strong></TableCell>
                                    <TableCell align='right'><strong>Deducted Amount</strong></TableCell>
                                    <TableCell><strong>Method</strong></TableCell>
                                </TableRow></TableHead>
                                <TableBody>{recoveryRows.map((recovery, index) => (
                                    <TableRow key={`${recovery.monthTag}-${index}`}>
                                        <TableCell>{recovery.monthTag || '-'}</TableCell>
                                        <TableCell>{recovery.recoverDate ? dayjs(recovery.recoverDate).format('DD-MM-YYYY') : '-'}</TableCell>
                                        <TableCell align='right'>{Number(recovery.amount || 0).toLocaleString()}</TableCell>
                                        <TableCell>{recovery.method || '-'}</TableCell>
                                    </TableRow>
                                ))}</TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions><Button onClick={() => setRecoveryDialog(false)}>Close</Button></DialogActions>
            </Dialog>
            <Footer />
        </>
    );
}
